<template>
  <div class="content-home">
    <div class="head">
      <!-- 搜查框 -->
      <!-- <a-auto-complete
        :dataSource="cityData"
        style="width: 50%"
        placeholder="请输入要查询的内容"
      /> -->
      <ZOrgChooser @orgSelect="selectedOrg" class="item" ref="orgChooser" :option="orgOption" />
      <!-- 省份选择 -->
      <a-select class="item" size="small" v-model="selected" defaultValue="中国" placeholder="请选择省份" @change="provinceChange">
        <a-select-option value="china">中国</a-select-option>
        <template v-for="(item, index) in provincesText">
          <a-select-option :key="index" :value="item">{{item}}</a-select-option>
        </template>
      </a-select>
      <a-select class="item" v-model="selectedModel" size="small" defaultValue="" placeholder="请选择设备型号" @change="deviceModelChange">
        <a-select-option value="all">全部设备</a-select-option>
        <template v-for="(item, index) in allDeviceType">
          <a-select-option :key="index" :value="item.value">{{item.name}}</a-select-option>
        </template>
      </a-select>
    </div>
    <!-- 地图 -->
    <div id="home_page_map" class="page_map"></div>
    <div v-show="showSmallMap" id="small_map" class="small_map"></div>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import config from '../../config'
  import bus from '../../bus/bus'
  import echarts from 'echarts'
  import ZOrgChooser from '@/components/common/OrgChooser'
  import chinaCity from './map-data/china-city'
  import china from 'echarts/map/js/china'
  // import sichuan from 'echarts/map/js/province/sichuan'
  import shanghai from 'echarts/map/js/province/shanghai'
  import hebei from 'echarts/map/js/province/hebei'
  import shanxi from 'echarts/map/js/province/shanxi'
  import neimenggu from 'echarts/map/js/province/neimenggu'
  import liaoning from 'echarts/map/js/province/liaoning'
  import jilin from 'echarts/map/js/province/jilin'
  import heilongjiang from 'echarts/map/js/province/heilongjiang'
  import jiangsu from 'echarts/map/js/province/jiangsu'
  import zhejiang from 'echarts/map/js/province/zhejiang'
  import anhui from 'echarts/map/js/province/anhui'
  import fujian from 'echarts/map/js/province/fujian'
  import jiangxi from 'echarts/map/js/province/jiangxi'
  import shandong from 'echarts/map/js/province/shandong'
  import henan from 'echarts/map/js/province/henan'
  import hubei from 'echarts/map/js/province/hubei'
  import hunan from 'echarts/map/js/province/hunan'
  import guangdong from 'echarts/map/js/province/guangdong'
  import guangxi from 'echarts/map/js/province/guangxi'
  import hainan from 'echarts/map/js/province/hainan'
  import sichuan from 'echarts/map/js/province/sichuan'
  import guizhou from 'echarts/map/js/province/guizhou'
  import yunnan from 'echarts/map/js/province/yunnan'
  import xizang from 'echarts/map/js/province/xizang'
  import shanxi1 from 'echarts/map/js/province/shanxi1'
  import gansu from 'echarts/map/js/province/gansu'
  import qinghai from 'echarts/map/js/province/qinghai'
  import ningxia from 'echarts/map/js/province/ningxia'
  import xinjiang from 'echarts/map/js/province/xinjiang'
  import beijing from 'echarts/map/js/province/beijing'
  import tianjin from 'echarts/map/js/province/tianjin'
  import chongqing from 'echarts/map/js/province/chongqing'
  import xianggang from 'echarts/map/js/province/xianggang'
  import aomen from 'echarts/map/js/province/aomen'
  import taiwan from 'echarts/map/js/province/taiwan'

  // import sichuan from 'echarts/map/json/province/sichuan.json'

  export default {
    components: {
      ZOrgChooser
    },
    data() {
      return {
        orgOption:{
          showDirect: false,
          value: "",
          id: "updateOrg",
          // 是否相对定位
          // isRelative: true
        },
        // cityData: [],
        // series: [],
        // titleData: [],
        // 当前显示的地图区域
        maxSoldDevices: 0,
        selected: 'china',
        selectedModel: '全部设备',
        // 选择的设备ID
        selectedModelId: undefined,
        // 选择的省份ID
        selectedProviceId:undefined,
        selectedOrgLink: undefined,
        // 中国的省汉字
        provincesText: chinaCity.provincesText,
        // 中国的省拼音
        provinces: chinaCity.provinces,
        // 所有设备类型
        allDeviceType: [],
        // 所有省份ID
        proviceIds: []
      }
    },
    computed: {
      ...mapState(['mapData']),
      // 地图参数
      mapOptions () {
        return {
          // 背景颜色
          backgroundColor: '#fff',
          // 标题
          title: {
            show: true,
            text: this.selected === 'china' ? '中国' : this.selected,
            textStyle: {
              // align: 'center',
              color: '#333',
              fontSize: 30
            },
            // textAlign: 'left'
            x: 'center',
            padding: [20, 0, 0, 0]
          },
          geo: {
            map: this.selected,
            // 不知道为什么，设定一个空的center，每次渲染地图都会到达该地图的中心点
            center: '',
            label: {
              emphasis: {
                show: false
              }
            },
            // 是否可以鼠标缩放，平移 可选值： 'scale' 'move' true为都开启
            roam: true,
            scaleLimit: {
              min: 1,
              max: 5
            },
            itemStyle: {
              // 地图区块的颜色
              normal: {
                areaColor: '#666',
                borderColor: '#ddd'
              },
              // focus时候的颜色
              emphasis: {
                areaColor: '#555'
              }
            }
          },
          // 提示
          tooltip: {
            trigger: 'item',
            formatter: (params) => {
              return [`接入：${params.value[2]}`,`库存:${params.value[3]}`].join('\n')
            }
          },
          // 数量渐变的颜色
          visualMap: [
            {
              min: 0,
              // 最大值应该动态变化
              max: this.maxSoldDevices,
              calculable: true,
              dimension: 2,
              inRange: {
                color: ['#50a3ba', '#eac736', '#d94e5d']
              },
              textStyle: {
                color: '#fff'
              }
            }
          ],
          series: [{
            name: '设备接入数',
            type: 'scatter',
            // 鼠标移动到地图上的样式
            cursor: this.selected === 'china' ? 'pointer' : 'default',
            // 使用的坐标系，geo为地理坐标系
            coordinateSystem: 'geo',
            data: this.mapData,
            pointSize: 10,
            // color: 'red',
            blurSize: 6,
            // 点的半径变化规律
            symbolSize:  (val) => {
              // debugger
              return 10 + Math.round((val[2] / ( this.maxSoldDevices * 0.05 )))
              // return 5 + val[2]
            },
            label: {
              normal: {
                formatter: '{b}',
                position: 'bottom',
                show: true
              }
            }
          }]
        }
      },
      // 地区选择
      chinaCitys () {
        let arr = []
        for (let i = 0; i < this.provincesText.length; i++) {
          let obj = {
            value: this.provincesText[i],
            label: this.provincesText[i]
          }
          arr.push(obj)
        }
        return arr
      },
      // 是否显示小的中国地图
      // 只有在大地图切换到省的时候才显示，以方便点击小地图切换会大的中国地图
      showSmallMap () {
        return this.selected !== 'china'
      },
      // 请求数据的参数
      mapDataParams () {
        let params = {
          region: this.selectedProviceId || undefined,
          orgLink: this.selectedOrgLink || undefined,
          model: this.selectedModelId || undefined
        }
        return params
      }
    },
    watch: {
      // 监听请求数据的参数
      mapDataParams (newValue, oldValue) {
        // console.log(newValue)
        if (newValue !== oldValue) {
          // console.log(true)
          // 获取新数据
          // console.log(newValue)
          this.getHomeData(newValue).then(() => {
            // 获取数据之后重载地图
            this.reloadMap()
            // 通知sidebar组件，数据改变了需要重新渲染piechart
            bus.$emit('onChange', true)
          })
        }
      }
    },
    methods: {
      ...mapActions(['getHomeData']),
      // 获取接入设备数的最大值
      getMaxSoldNum () {
        let tem = 0
        // console.log(this.mapData)
        for (let i = 0; i < this.mapData.length; i++) {
          if (this.mapData[i].value[2] > tem) {
            tem = this.mapData[i].value[2]
            // console.log(tem)
          }
        }
        return tem
      },
      selectedOrg (ev) {
        // console.log(ev)
        if (ev) {
          this.selectedOrgLink = ev.link
        } else {
          this.selectedOrgLink = undefined
        }
      },
      // 获取所有省份ID
      getAllProvinceID() {
        this.$http.post(config.api.get_all_province_id, {}).then((res) => {
          // console.log(res)
          let {code, desc, result} = res
          if (code === 0 && desc === 'success' && result){
            this.proviceIds = result
            // console.log(this.proviceIds)
          }
        })
      },
      // 获取所有设备型号
      getAllDeviceModel () {
        this.$http.get(config.api.get_device_models).then((res) => {
          let {code, desc, result} = res
          if (code === 0 && desc === 'success' && result){
            // console.log(result)
            // 合并数组
            // let arr = [...result[0].models, ...result[1].models]
            // console.log(arr)
            result.forEach((device) => {
              this.allDeviceType.push({
                name: device.name,
                value: device.id
              })
            })
          }
        })
      },
      // 判断当前要加载的地图是不是省？
      isProvince (name) {
        return this.provincesText.some((province) => {
          return province === name
        })
      },
      /* 
      重载地图
      */
      reloadMap () {
        // 如果map存在就切换地图
        this.map && this.map.setOption(this.mapOptions)
      },
      // 获取当前省的id
      /* 
        name: 当前省的名字
        return 当前省的ID
      */
      getCurrentProvinceId (name) {
        if (name && name !== 'china') {
          let currentProvince = this.proviceIds.filter((province) => {
            return province.name.indexOf(name) !== -1
          })
          // console.log(currentProvince)
          if(currentProvince.length === 1) {
            return currentProvince[0].id
          }
        }
      },
      // 省选择改变
      provinceChange (e) {
        // console.log(e)
        if (e) {
          // console.log(e)
          // e 当前省的名字
          this.selected = e
          this.selectedProviceId = this.getCurrentProvinceId(e)
        } else {
          this.selectedProviceId = undefined
        }
      },
      /* 
        设备型号选择改变
      */
      deviceModelChange (e) {
        // console.log(`设备id:${e}`)
        // e => 设备id
        if (e && e !== 'all') {
          this.selectedModelId = e
        } else if (e === 'all') {
          this.selectedModelId = undefined
        }
        // this.selectedModel = e
      },
      createSmallMap () {
        // 创建小地图
        let smallMap = echarts.init(document.getElementById('small_map'))
        // console.log(smallMap)
        smallMap.setOption({
          geo: {
            map: 'china',
            label: {
              emphasis: {
                show: false
              }
            },
            roam: false,
            itemStyle: {
              normal: {
                areaColor: '#e35',
                borderColor: '#e35'
              },
              emphasis: {
                areaColor: '#e35'
              }
            }
          }
        })
        // 点击监听
        smallMap.on('click', (ev) => {
          // console.log(ev)
          // 如果大地图在省那就切换回中国地图
          if (this.selected !== 'china') {
            this.selected = 'china'
            this.selectedProviceId = undefined
            // this.map && this.map.setOption(this.mapOptions)
          }
        })
        
      },
      createMap() {
        // 创建地图
        let map = echarts.init(document.getElementById('home_page_map'))
        // 地图图表设置
        map.setOption(this.mapOptions)
        this.map = map
        // 监听点击事件
        map.on('click', (ev) => {
          console.log(ev)
          // 如果点击的是某一个省，说明此时实在中国地图上
          if (this.isProvince(ev.name)) {
            // 让地图跳转到当前省
            this.selected = ev.name
            this.selectedProviceId = this.getCurrentProvinceId(ev.name)
            // map.setOption(this.mapOptions)
            // 在这个地图的右下角创建一个小的中国地图
            // 监听小地图的点击事件
            // 点击小地图让大地图切换会中国地图，并且销毁小的地图
            // 这个方法比较消耗性能，使用过程中会频繁点击，创建和销毁dom,不停的重排和重绘
            // 用户体验问题
            // 换一个思路 -> 切换回中国地图
          } 
          // else {
          //   this.selected = 'china'
          // }
          // map.setOption(this.mapOptions)
          // this.loadMap(this.selected)
        })
      },
      queryOrgTree () {
        return new Promise(resolve => {
          this.$http.get(config.api.query_orgtree_bylevel + 3).then(res => {
            let {code, desc, result} = res
            // 如果请求的结果是成功的，那就整理数据并赋值
            if (code === 0 && desc === 'success' && result) {
              resolve(result)
            }
          })
        })
      }
    },
    created() {
      // this.queryDeviceDistribute()
      this.getHomeData({}).then(() => {
        // console.log(this.mapData)
        // this.map && this.map.setOption(this.mapOptions)
        this.maxSoldDevices = this.getMaxSoldNum()
        // console.log(this.maxSoldDevices)
        this.reloadMap()
        bus.$emit('onChange', true)
      })
      this.getAllProvinceID()
      this.getAllDeviceModel()
    },
    mounted () {
      // 创建地图
      this.createMap()
      // 创建小地图
      this.createSmallMap()
      // 
      this.queryOrgTree().then((res) => {
        this.$refs["orgChooser"].initOrgTree(res)
      })
      setTimeout(() => {
        window.onresize = () => {
          // console.log(this.map)
          this.map.resize()
          bus.$emit('windowResize', true)
        }
      }, 500)
    }
  }
</script>
<style lang="less" scoped>
.content-home {
  box-shadow: 0 5px 10px rgb(151, 147, 147);
  height: 87vh;
  .head {
    display: flex;
    flex-direction: row;
    margin: 0 0 10px 0;
    height: 5vh;
    // box-shadow: 0 1px 5px #333;
    padding-top: 15px;
    .item {
      flex: 1;
      margin: 0 10px;
      box-sizing: border-box;
    }
  }
  .page_map {
    border-radius: 5px;
    height: 81vh;
  }
  .small_map {
    position: fixed;
    width: 190px;
    height: 120px;
    background: rgba(105, 100, 100, 0.363);
    bottom: 10%;
    right: 40%;
    z-index: 100;
  }
}
</style>
